import { Visit, VisitStatus } from '@curebase/core/types';

const { MissedAll, MissedPartial } = VisitStatus;

export default function isDataCaptureMissed<V extends Pick<Visit, 'status'>>(
  v: V
): boolean {
  return [MissedAll, MissedPartial].includes(v.status);
}
